import React from 'react'
import { array, string } from 'prop-types'
import styled from 'styled-components'
import { Flex, Box, Heading } from 'rebass'

import media, { Container } from '../../utils/style'
import ContentFeatureList from '../ContentFeatureList'
import IconStar from '../../vectors/IconStar'

const Wrapper = styled(Flex)`
  position: relative;
  background: white;
`

const Overview = styled(Box)`
  background-color: ${(props) => props.theme.colors.blue_light};
  align-items: flex-start;

  ${media.MediumScreenUp`
    min-height: 300px;
  `};

  ${media.GiantScreenUp`
    min-height: 350px;
  `};
`

class ContentVehicleOverview extends React.PureComponent {
  render() {
    const IconStarTag = <IconStar />
    return (
      <Wrapper
        flexWrap="wrap"
        mb={0}
        id="vehicle-overview"
        key="vehicle-overview"
      >
        {this.props.list && this.props.list.length > 0 && (
          <Overview width={12 / 12} pt={[40, null, 50]} pb={[80, null, 80]}>
            <Container mx={'5%'} px={0} maxWidth={'100%'} id={this.props.id}>
              <Heading as="h3" fontSize={24} fontWeight={600} pb={[10, 10, 20]}>
                Key Specifications
              </Heading>
              <ContentFeatureList
                list={this.props.list}
                icon={IconStarTag}
                flex="0 1 25%"
                spacing={{ t: 0, l: 0, b: 24, r: 15 }}
              />
            </Container>
          </Overview>
        )}
      </Wrapper>
    )
  }
}

ContentVehicleOverview.defaultProps = {
  sections: [],
  list: [],
  id: 'content-vehicle-overview'
}
ContentVehicleOverview.propTypes = {
  sections: array,
  list: array,
  id: string
}

export default ContentVehicleOverview
